import { Type } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  ParkingManagementResponse,
  ParkingManagementError,
  ParkingManagement,
  AddParkingManagementResponse,
  DeletedParkingManagement,
  ParkingManagementType,
  AddParkingManagementTypeResponse,
  DeletedParkingManagementType,
} from '@core/interface/parking-managment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ParkingManagementActions = createActionGroup({
  source: 'ParkingManagement',
  events: {
    'Load ParkingManagement': props<PagePayload>(),
    'Load ParkingManagement Success': props<ParkingManagementResponse>(),
    'Load ParkingManagement Failure': props<ParkingManagementError>(),
    'Add Edit ParkingManagement': props<{ parking: ParkingManagement }>(),
    'Add ParkingManagement Success': props<AddParkingManagementResponse>(),
    'Add ParkingManagement Failure': props<ParkingManagementError>(),
    'Reset Delete status': emptyProps(),
    'Add Mark As Paid ParkingManagement': props<{
      ParkingManagement: ParkingManagement;
    }>(),
    'Add Mark As Paid Success': props<AddParkingManagementResponse>(),
    'Add Mark As Paid Failure': props<ParkingManagementError>(),
  },
});
